import { render, staticRenderFns } from "./ADFormActivity.vue?vue&type=template&id=b0b6389e&scoped=true&"
import script from "./ADFormActivity.vue?vue&type=script&lang=js&"
export * from "./ADFormActivity.vue?vue&type=script&lang=js&"
import style0 from "./ADFormActivity.vue?vue&type=style&index=0&id=b0b6389e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b6389e",
  null
  
)

export default component.exports